module.exports = __webpack_public_path__ + "static/media/vertical-logo.abc33532.png";